import Clarity from '@microsoft/clarity';
import { v4 as uuid } from 'uuid';
import { getSessionStorageItem } from 'utils/getSessionStorageItem';
import { setSessionStorageItem } from 'utils/setSessionStorageItem';

class ApplicationConfig {
  public transactionId: string;
  public sessionId: string;

  constructor() {
    const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID || '';

    // Initialize Clarity
    Clarity.init(projectId);
    this.transactionId = uuid();

    const currectSessionId = getSessionStorageItem('session_id');

    if (currectSessionId) {
      this.sessionId = currectSessionId;
    } else {
      const newSessionId = uuid();

      setSessionStorageItem('session_id', newSessionId);
      this.sessionId = newSessionId;
    }

    Clarity.setTag('transactionId', this.transactionId);
    Clarity.setTag('sessionId', this.sessionId);
  }

  public updateTransactionId() {
    this.transactionId = uuid();
    Clarity.setTag('transactionId', this.transactionId);
  }
}

const applicationConfig = new ApplicationConfig();

export default applicationConfig;
